<template lang="pug">
  .b2b-login-password-form-redes
    login-password-form-generic(
      :logo='logo'
      :next='next'
      :back='back')
</template>

<script>
import B2bLoginPasswordFormGeneric from '@/components/logingeneric/B2bLoginPasswordFormGeneric'

export default {
  name: 'login-password-form-redes',

  data () {
    return {
      logo: 'redes.png',
      next: '/red.es/new-password-final-form',
      back: '/red.es'
    }
  },
  components: {
    'login-password-form-generic': B2bLoginPasswordFormGeneric
  }

}
</script>
<style lang="scss" scoped>
  ::v-deep .ods-input, .ods-input__inner {
    background-color: #fdf1f4!important;
    color: #fdf1f4!important;
    border: 1px solid #C8103A;
  }
  ::v-deep .ods-button__custom {
    background-color: #C8103A!important;
  }
  ::v-deep .ods-p-32{
    color: #C8103A!important;
  }
</style>
